import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { DividerModule } from 'primeng/divider';
import { TimelineModule } from 'primeng/timeline';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { StyleClassModule } from 'primeng/styleclass';

import { ActivatedRoute, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, map, Observable, of, Subscription, interval, forkJoin, take } from 'rxjs';

import { environment } from 'apps/ff-frontend/src/environments/environment';
import {
  GetBalanceOrderStatus,
  GetChargeOrderStatus,
  GetOrderStatusOfQuotation,
  NotificationError,
  SubscriptionSignupCharges,
  SubscriptionSignUpOrderSummaryResponse,
  SubscriptionSignupService,
  SubscriptionSignUpStatus,
  SubscriptionSignupTaxLineItem,
  SubscriptionSignUpWithBillingJsonResponse,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import { SubscriptionService, SubscriptionSignupByUuidService } from '@fitness-force/api';

import { ProgressBarModule } from 'primeng/progressbar';
import { DrawerModule } from 'primeng/drawer';
import { ChargeQuatationStatus, PlanCategory, PlanIntervalType, SignUpStatus } from '@fitness-force/enum';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import {
  COMPANY_INFO,
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { QrCodeModule } from 'ng-qrcode';

import { SkeletonModule } from 'primeng/skeleton';
import Statsig from 'statsig-js';
import { NotFoundError } from '@fitness-force/errors';
import { MessageModule } from 'primeng/message';
import { ToastMessageService } from '../../../../api/src/lib/toastmessage/toastmessage.service';

@Component({
  selector: 'payment-status-timeline',
  templateUrl: './payment-status-timeline.component.html',
  styleUrls: ['./payment-status-timeline.component.scss'],
  providers: [ToastMessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    PopoverModule,
    DividerModule,
    TimelineModule,
    ButtonModule,
    StyleClassModule,
    TooltipModule,
    ProgressBarModule,
    DrawerModule,
    CurrencyformatPipe,
    QrCodeModule,
    SkeletonModule,
    RouterModule,
    TranslateModule,
    MessageModule
  ]
})
export class PaymentStatusTimelineComponent implements OnInit, OnDestroy {
  @Input('uuid') uuid = '';
  @Input('isPayment') ispayment = false;
  @Input('visible') showPaymentStatusSidebar = false;
  @Output() hidePaymentSummaryPopup: EventEmitter<boolean> = new EventEmitter();
  @Output() GoToClientSubscription: EventEmitter<boolean> = new EventEmitter();

  subsData$ = new BehaviorSubject({} as SubscriptionSignUpOrderSummaryResponse);

  getAccessTenantList$!: Observable<any>;
  tenantId = 0;

  bitlyLink= '';

  showContractSidebar = false;
  showSkeleton$ = new BehaviorSubject<boolean>(true);
  //showSkeleton: boolean = true;
  showLoader = true;
  isOffline = false;

  planIntervalType?: PlanIntervalType;
  paymentStatus2!: any[];
  timerSubscription!: Subscription;
  subscriptionSignUpStatusArray: SubscriptionSignUpStatus[] = [];
  subscriptionSignUpStatus$ = new BehaviorSubject<SubscriptionSignUpStatus[]>(
    []
  );
  clientId!: number;
  subscriptionId!: number;
  waiverPayload: any;
  clientMandatoryFieldPayload: any;
  showSignUplink = false;

  subsciptionUuid = "";
  showResendLink = new BehaviorSubject<boolean>(true);

  companyUuid = '';
  tenantUuid = '';

  private lastPollingTime: number = 0;
  private readonly pollingInterval = 20000; // 20 seconds in milliseconds
  private pollCount: number = 0;
  private readonly maxPollCount: number = 15;
  showRefreshButton = new BehaviorSubject<boolean>(false);
  private pollingSubscription?: Subscription;
  refreshButtonLoader = new BehaviorSubject<boolean>(false);
  progressBarMode= 'indeterminate';

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private subscriptionSignUp: SubscriptionSignupByUuidService,
    private toastMessageService: ToastMessageService,
    public currencyPipe: CurrencyformatPipe,
    private translate: TranslateService,
    private subscriptionService: SubscriptionService,
    private cd: ChangeDetectorRef
  ) {
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  ngOnInit(): void {
    //this.getOrderDetails(this.uuid);
    this.componentInit();
    // Add visibility change listener
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  ngOnDestroy(): void {
    this.stopPolling();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentInit(): void {
    const companyInfoDetail$: Observable<any> = this.store.select(COMPANY_INFO);
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);

    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.tenantUuid = tenant.selected_tenant.tenant_uuid;
        this.store.dispatch({ type: 'ROUTER_GO' });
        companyInfoDetail$.subscribe((responseData) => {
          this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
          this.translate.use(responseData?.selectedLang?.LANG_CODE);
          this.companyUuid = responseData?.compDetails?.uuid;
          this.getWaiverAndOrderDetails();
        });
      }
    });

   
   
    if (Statsig.checkGate("staff_can_see_signup_link")) {
      this.showSignUplink = false;
    } else {
      this.showSignUplink = true;
    }

   
  }

  getWaiverAndOrderDetails(): void {
      forkJoin({
        waiverPayload: (!this.ispayment) ? this.subscriptionSignUp.GetWaivers(environment.BASE_URL, this.companyUuid, this.tenantUuid, this.uuid) : of(null)
        // , clientMandateInfo: (!this.ispayment) ? this.subscriptionSignUp.GetClientMandatoryField(environment.BASE_URL, this.uuid) : of(null)
        , orderStatusQuotation: (!this.ispayment) ? this.subscriptionSignUp.GetOrderDetails(environment.BASE_URL, this.companyUuid, this.tenantUuid, this.uuid) : of(null)
      }
      ).subscribe(({ waiverPayload, orderStatusQuotation }) => {
        //Order Object -------
        let istep = 0;

        this.showSkeleton$.next(false);

        if (orderStatusQuotation && orderStatusQuotation.signUpOrderSummaryResponse) {
          this.subsData$.next(orderStatusQuotation.signUpOrderSummaryResponse.order_details);
          if (
            orderStatusQuotation.signUpOrderSummaryResponse.status == SignUpStatus.SignUpSuccessfull || orderStatusQuotation.signUpOrderSummaryResponse.status.toString() == SignUpStatus[SignUpStatus.SignUpSuccessfull]
            || orderStatusQuotation.signUpOrderSummaryResponse.status == SignUpStatus.SignUpFailed || orderStatusQuotation.signUpOrderSummaryResponse.status.toString() == SignUpStatus[SignUpStatus.SignUpFailed]
            || orderStatusQuotation.signUpOrderSummaryResponse.status == SignUpStatus.SignUpExpired || orderStatusQuotation.signUpOrderSummaryResponse.status.toString() == SignUpStatus[SignUpStatus.SignUpExpired]
          ) {
            this.isOffline = true;
            this.showLoader = false;
          }
          this.bitlyLink = orderStatusQuotation.signUpOrderSummaryResponse.full_link
          this.planIntervalType = orderStatusQuotation.signUpOrderSummaryResponse.order_details.billing_interval_type;
          // console.log("subscriptionSignUpOrderSummaryResponse object : ", orderStatusQuotation.signUpOrderSummaryResponse)

          //Order Object -------

          //if (waiverPayload && waiverPayload.items && waiverPayload.items.length > 0)
          this.subscriptionSignUpStatusArray.push({ key: SignUpStatus.Created, title: "SENDWAIVER", text: "SENDWAIVER_DTL", icon: "fa fa-check", step: (++istep), status: "Done", });

          if (waiverPayload && !this.ispayment && waiverPayload.items && waiverPayload.items.length > 0)
            this.subscriptionSignUpStatusArray.push({ key: SignUpStatus.WaiverDone, title: "CLIENTSIGN_WAIVER", text: "CLIENTSIGN_WAIVER_DTL", icon: "", step: (++istep), status: "Pending", });

          // if (clientMandateInfo && clientMandateInfo.length)
          if (!this.ispayment)
            this.subscriptionSignUpStatusArray.push({ key: SignUpStatus.MandatoryInformationDone, title: "MEMBERDETAILS", text: "MEMBERDETAILS_DTL", icon: "", step: (++istep), status: "Not Done", });

          if (!orderStatusQuotation.signUpOrderSummaryResponse.order_details.is_offline_payment)
            this.subscriptionSignUpStatusArray.push({ key: SignUpStatus.AwaitingPayment, title: "AWAITINGPAYMENT", text: "AWAITINGPAYMENT_DTL", icon: "", step: (++istep), status: "Not Done" });

          // if (this.isRecurring(orderStatusQuotation.signUpOrderSummaryResponse.order_details) && (!orderStatusQuotation.signUpOrderSummaryResponse.order_details.is_offline_payment || !orderStatusQuotation.signUpOrderSummaryResponse.order_details.feature_is_cash_recurring))
          //   this.subscriptionSignUpStatusArray.push({ key: SignUpStatus.AwaitingPayment, title: "PAYMENT_METHOD", text: "PAYMENT_METHOD_DET", icon: "", step: (++istep), status: "Not Done" });

          this.subscriptionSignUpStatusArray.push({ key: SignUpStatus.SignUpSuccessfull, title: "SUBSCRIPTIONCREATED", text: "SUBSCRIPTIONCREATED_DTL", icon: "", step: (++istep), status: "Not Done" });

         

          this.subscriptionSignUpStatus$.next(this.subscriptionSignUpStatusArray);

          // timer(0, 10000) call the function immediately and every 10 seconds
          // this.timerSubscription = timer(0, 10000).pipe(
          //   map(() => {
          //     this.GetOrderSubscriptionStatus(this.uuid); // load data contains the http request
          //   })
          // ).subscribe();
          this.startPolling();
        }
        else if (orderStatusQuotation && orderStatusQuotation.balanceOrderStatus) { }
      });
  }

  getOrderDetails(uuid: string): void {
    //let subscriptionPayload: SubscriptionSignUpOrderSummaryResponse =

    this.subscriptionSignUp.GetOrderDetails(environment.BASE_URL, this.companyUuid, this.tenantUuid, uuid).subscribe({
      next: (getOrderStatusOfQuatation: GetOrderStatusOfQuotation) => {
        this.showSkeleton$.next(false);
        let subscriptionSignUpWithBillingJsonResponse = {} as SubscriptionSignUpWithBillingJsonResponse;


        if (getOrderStatusOfQuatation && getOrderStatusOfQuatation.signUpOrderSummaryResponse) {

          subscriptionSignUpWithBillingJsonResponse = getOrderStatusOfQuatation.signUpOrderSummaryResponse;
          this.subsData$.next(subscriptionSignUpWithBillingJsonResponse.order_details);
          if (
            subscriptionSignUpWithBillingJsonResponse.status == SignUpStatus.SignUpSuccessfull || subscriptionSignUpWithBillingJsonResponse.status.toString() == SignUpStatus[SignUpStatus.SignUpSuccessfull]
            || subscriptionSignUpWithBillingJsonResponse.status == SignUpStatus.SignUpFailed || subscriptionSignUpWithBillingJsonResponse.status.toString() == SignUpStatus[SignUpStatus.SignUpFailed]
            || subscriptionSignUpWithBillingJsonResponse.status == SignUpStatus.SignUpExpired || subscriptionSignUpWithBillingJsonResponse.status.toString() == SignUpStatus[SignUpStatus.SignUpExpired]
          ) {
            this.isOffline = true;
            this.showLoader = false;
          }
          this.bitlyLink = subscriptionSignUpWithBillingJsonResponse.full_link
          this.planIntervalType = subscriptionSignUpWithBillingJsonResponse.order_details.billing_interval_type;
        }
        else if (getOrderStatusOfQuatation && getOrderStatusOfQuatation.balanceOrderStatus) {
          const balanceOrderStatus = {} as GetBalanceOrderStatus;
          // this has to be implemented
          //balanceOrderStatus = getOrderStatusOfQuatation.balanceOrderStatus;
          //this.subsData$.next();
        }
        else if (getOrderStatusOfQuatation && getOrderStatusOfQuatation.chargeOrderStatus) {
          const chargeOrderStatus = {} as GetChargeOrderStatus;
          // this has to be implemented
          //balanceOrderStatus = getOrderStatusOfQuatation.balanceOrderStatus;

          if (
            chargeOrderStatus.status == ChargeQuatationStatus.Successfull || chargeOrderStatus.status.toString() == ChargeQuatationStatus[ChargeQuatationStatus.Successfull]
            || chargeOrderStatus.status == ChargeQuatationStatus.Failed || chargeOrderStatus.status.toString() == ChargeQuatationStatus[ChargeQuatationStatus.Failed]
            || chargeOrderStatus.status == ChargeQuatationStatus.Expired || chargeOrderStatus.status.toString() == ChargeQuatationStatus[ChargeQuatationStatus.Expired]
          ) {
            this.isOffline = true;
            this.showLoader = false;
          }
          //this.subsData$.next();
        }
      }
    });

  }

  private handleVisibilityChange(): void {
    if (document.hidden) {
      // Stop polling when page is hidden
      this.stopPolling();
      // Store the last polling time
      this.lastPollingTime = Date.now();
    } else {
      // Page is visible again
      const timeSinceLastPoll = Date.now() - this.lastPollingTime;
      
      // If it's been longer than our polling interval since the last poll,
      // do an immediate poll and restart the interval
      if (timeSinceLastPoll >= this.pollingInterval) {
        this.GetOrderSubscriptionStatus(this.uuid);
      }
      
      // Restart polling if we haven't reached max count
      if (this.pollCount < this.maxPollCount) {
        this.startPolling();
      }
    }
  }

  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = undefined;
    }
  }

  startPolling(): void {
    // Prevent multiple polling subscriptions
    if (this.pollingSubscription || document.hidden) {
      return;
    }

    // Make an immediate call first if we haven't reached max count
    if (this.pollCount < this.maxPollCount) {
      this.GetOrderSubscriptionStatus(this.uuid);
    }

    // Start the interval
    this.pollingSubscription = interval(this.pollingInterval)
      .pipe(
        take(this.maxPollCount - this.pollCount) // Ensure we don't exceed maxPollCount
      )
      .subscribe({
        next: () => {
          if (document.hidden) {
            this.stopPolling();
            return;
          }
          
          this.pollCount++;
          this.GetOrderSubscriptionStatus(this.uuid);
          
          if (this.pollCount >= this.maxPollCount) {
            this.stopPolling();
            this.progressBarMode = 'determinate';
            this.showRefreshButton.next(true);
          }
        },
        complete: () => {
          this.stopPolling();
          this.showRefreshButton.next(true);
        }
      });
  }

  // Add method to manually refresh status
  refreshStatus(): void {
    this.progressBarMode = 'indeterminate';
    this.GetOrderSubscriptionStatus(this.uuid);
    setTimeout(() => {
      this.progressBarMode = 'determinate';
      this.cd.detectChanges();
    }, 1000);
  }

  GetOrderSubscriptionStatus(uuid: string): void {
    this.refreshButtonLoader.next(true);
    this.subscriptionSignUp.GetOrderSubscriptionStatus(environment.BASE_URL, this.companyUuid, this.tenantUuid, uuid).subscribe({
      next: (getOrderStatusOfQuatation: GetOrderStatusOfQuotation) => {
        this.refreshButtonLoader.next(false);
        if (getOrderStatusOfQuatation && getOrderStatusOfQuatation.signUpOrderSummaryResponse) {
          const res = getOrderStatusOfQuatation.signUpOrderSummaryResponse;
          this.clientId = res.client_id;
          if (
            res.status == SignUpStatus.SignUpSuccessfull || res.status.toString() == SignUpStatus[SignUpStatus.SignUpSuccessfull]) {
            this.setTimeLineStatus(SignUpStatus.SignUpSuccessfull);
            this.subscriptionId = res.client_subscription_id;
            this.subsciptionUuid = res.uuid;
            this.showResendLink.next(true);
            // Stop polling on success
            this.stopPolling();
          }
          else if (res.status == SignUpStatus.SignUpFailed || res.status.toString() == SignUpStatus[SignUpStatus.SignUpFailed]
            || res.status == SignUpStatus.SignUpExpired || res.status.toString() == SignUpStatus[SignUpStatus.SignUpExpired]) {
            this.showLoader = false;
            // Stop polling on failure/expiry
            this.stopPolling();
          }
          else {
            this.setTimeLineStatus(res.status);
          }
          this.subscriptionSignUpStatus$.next(this.subscriptionSignUpStatusArray);
        }
      },
      error: (err) => {
        console.error('Status check error:', err);
        // Don't stop polling on error unless we've reached max count
        if (this.pollCount >= this.maxPollCount) {
          this.stopPolling();
          this.showRefreshButton.next(true);
        }
      }
    });
  }

  // firePaymentHideEvent(event: any) {
  //   this.showPaymentStatusSidebar = false;
  //   this.hidePaymentSummaryPopup.emit(this.showPaymentStatusSidebar);
  // }

  payingToday(oData: SubscriptionSignUpOrderSummaryResponse): number {
    return (
      this.nonRecurringAmount(oData) +
      this.nonRecurringTaxAmount(oData) +
      this.proRataAmount(oData) +
      this.proRataTaxAmount(oData) +
      this.chargeAmount(oData) +
      this.chargeTaxAmount(oData)
    );
  }

  proRataAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (
      oData.charging_today &&
      oData.charging_today.service_first_charge &&
      oData.charging_today.service_first_charge.services
    ) {
      for (
        let i = 0;
        i < oData.charging_today.service_first_charge.services.length;
        i++
      ) {
        amount =
          amount +
          oData.charging_today.service_first_charge.services[i]
            .taxable_cost_in_minor_curr;
      }
    }
    return amount;
  }

  proRataTaxAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (
      oData.charging_today &&
      oData.charging_today.service_first_charge &&
      oData.charging_today.service_first_charge.services
    ) {
      for (
        let i = 0;
        i < oData.charging_today.service_first_charge.services.length;
        i++
      ) {
        for (
          let j = 0;
          j <
          oData.charging_today.service_first_charge.services[i].tax
            .tax_line_items.length;
          j++
        ) {
          amount =
            amount +
            oData.charging_today.service_first_charge.services[i].tax
              .tax_line_items[j].amt_in_minor_curr;
        }
      }
    }

    return amount;
  }

  recurringAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (oData.charging_recurring && oData.charging_recurring.services) {
      for (let i = 0; i < oData.charging_recurring.services.length; i++) {
        amount =
          amount +
          oData.charging_recurring.services[i].taxable_cost_in_minor_curr;
      }
    }

    return amount;
  }

  recurringTaxAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (oData.charging_recurring && oData.charging_recurring.services) {
      for (let i = 0; i < oData.charging_recurring.services.length; i++) {
        for (
          let j = 0;
          j < oData?.charging_recurring?.services[i]?.tax?.tax_line_items?.length;
          j++
        ) {
          amount =
            amount +
            oData?.charging_recurring?.services[i]?.tax?.tax_line_items[j]
              .amt_in_minor_curr;
        }
      }
    }

    return amount;
  }

  nonRecurringAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (
      oData.charging_today &&
      oData.charging_today.service_non_recurring &&
      oData.charging_today.service_non_recurring.services
    ) {
      for (
        let i = 0;
        i < oData.charging_today.service_non_recurring.services.length;
        i++
      ) {
        amount =
          amount +
          oData.charging_today.service_non_recurring.services[i]
            .taxable_cost_in_minor_curr;
      }
    }
    return amount;
  }

  nonRecurringTaxAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (
      oData.charging_today &&
      oData.charging_today.service_non_recurring &&
      oData.charging_today.service_non_recurring.services
    ) {
      for (
        let i = 0;
        i < oData.charging_today.service_non_recurring.services.length;
        i++
      ) {
        for (
          let j = 0;
          j <
          oData.charging_today.service_non_recurring.services[i].tax
            .tax_line_items.length;
          j++
        ) {
          amount =
            amount +
            oData.charging_today.service_non_recurring.services[i].tax
              .tax_line_items[j].amt_in_minor_curr;
        }
      }
    }

    return amount;
  }

  chargeAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (oData.charging_today && oData.charging_today.signup_charges) {
      for (let i = 0; i < oData.charging_today.signup_charges.length; i++) {
        amount =
          amount +
          oData.charging_today.signup_charges[i].chrgmst_net_cost_in_minor_curr;
      }
    }
    return amount;
  }

  chargeTaxAmount(oData: SubscriptionSignUpOrderSummaryResponse): number {
    let amount = 0;
    if (oData.charging_today && oData.charging_today.signup_charges) {
      for (let i = 0; i < oData.charging_today.signup_charges.length; i++) {
        for (
          let j = 0;
          j < oData.charging_today.signup_charges[i].tax.tax_line_items.length;
          j++
        ) {
          amount =
            amount +
            oData.charging_today.signup_charges[i].tax.tax_line_items[j]
              .amt_in_minor_curr;
        }
      }
    }
    return amount;
  }

  allServiceNameHtml(oData: SubscriptionSignUpOrderSummaryResponse): string {
    const serviceCategoryName: string[] = [];
    const serviceCategory: any[] = [];
    oData.charging_recurring?.services?.forEach(
      (oService: SubscriptionSignupService) => {
        if (
          serviceCategoryName.indexOf(oService.category_name_pri_lang) == -1
        ) {
          serviceCategoryName.push(oService.category_name_pri_lang);
          serviceCategory.push({
            name: oService.category_name_pri_lang,
            isBaseMembership: oService.is_base_membership,
          });
        }
      }
    );

    oData.charging_today?.service_non_recurring?.services?.forEach(
      (oService: SubscriptionSignupService) => {
        if (
          serviceCategoryName.indexOf(oService.category_name_pri_lang) == -1
        ) {
          serviceCategoryName.push(oService.category_name_pri_lang);
          serviceCategory.push({
            name: oService.category_name_pri_lang,
            isBaseMembership: oService.is_base_membership,
          });
        }
      }
    );

    const str = `
        <div>
          <div class="mt-2 mb-0 md:mb-1 text-xs text-600">
              {{First}}
              {{Others}}
          </div>
        </div>
    `;
    // <div class="text-right ml-3">{{recurringAmount}}</div>

    let other = '';
    let first= '';
    for (let i = 0; i < serviceCategory.length; i++) {
      if (i == 0)
        first =
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round"> Base Membership </span>'
            : '');
      else
        other =
          other +
          '<br class="md:hidden"> + ' +
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round" > Base Membership </span>'
            : '');
    }

    const strAmount = this.currencyPipe.transform(
      this.recurringAmount(oData) + this.recurringTaxAmount(oData),
      undefined
    );
    return str
      .replace('{{First}}', first)
      .replace('{{Others}}', other)
      .replace('{{recurringAmount}}', strAmount);
  }

  serviceNonRecurringNameHtml(
    oData: SubscriptionSignUpOrderSummaryResponse
  ): string {
    const serviceCategoryName: string[] = [];
    const serviceCategory: any[] = [];
    oData.charging_today?.service_non_recurring?.services?.forEach(
      (oService: SubscriptionSignupService) => {
        if (
          serviceCategoryName.indexOf(oService.category_name_pri_lang) == -1
        ) {
          serviceCategoryName.push(oService.category_name_pri_lang);
          serviceCategory.push({
            name: oService.category_name_pri_lang,
            isBaseMembership: oService.is_base_membership,
          });
        }
      }
    );

    const str = `
      <div>
        <div>One time add-on's</div>
        <div class="mt-2 mb-0 md:mb-1 text-xs text-60">
          {{First}}
          {{Others}}
        </div>
      </div>
      <div class="text-right ml-3">{{recurringAmount}}</div>
    `;

    let other = '';
    let first = '';
    for (let i = 0; i < serviceCategory.length; i++) {
      if (i == 0) first = serviceCategory[i].name;
      else
        other = other + '<br class="md:hidden"> + ' + serviceCategory[i].name;
    }

    const strAmount = this.currencyPipe.transform(
      this.nonRecurringAmount(oData),
      undefined
    );
    return str
      .replace('{{First}}', first)
      .replace('{{Others}}', other)
      .replace('{{recurringAmount}}', strAmount);
  }

  getTaxDetails(oData: SubscriptionSignUpOrderSummaryResponse): string {
   const tax: string[] = [];
    oData.charging_today?.signup_charges?.forEach(
      (oCharges: SubscriptionSignupCharges) => {
        if (
          oCharges.tax &&
          oCharges.tax.tax_line_items &&
          oCharges.tax.tax_line_items.length > 0
        )
          oCharges.tax.tax_line_items.forEach(
            (oTax: SubscriptionSignupTaxLineItem) => {
              if (tax.indexOf(oTax.name_pri_lang) == -1)
                tax.push(oTax.name_pri_lang);
            }
          );
      }
    );

    oData.charging_today?.service_first_charge?.services?.forEach(
      (oService: SubscriptionSignupService) => {
        if (
          oService.tax &&
          oService.tax.tax_line_items &&
          oService.tax.tax_line_items.length > 0
        )
          oService.tax.tax_line_items.forEach(
            (oTax: SubscriptionSignupTaxLineItem) => {
              if (tax.indexOf(oTax.name_pri_lang) == -1)
                tax.push(oTax.name_pri_lang);
            }
          );
      }
    );

    oData.charging_today?.service_non_recurring?.services?.forEach(
      (oService: SubscriptionSignupService) => {
        if (
          oService.tax &&
          oService.tax.tax_line_items &&
          oService.tax.tax_line_items.length > 0
        )
          oService.tax.tax_line_items.forEach(
            (oTax: SubscriptionSignupTaxLineItem) => {
              if (tax.indexOf(oTax.name_pri_lang) == -1)
                tax.push(oTax.name_pri_lang);
            }
          );
      }
    );

    return tax.join('</br>');
  }

  ordinalNumber(n: number | null | undefined): string {
    if (n) {
      let s = ['th', 'st', 'nd', 'rd'];
      let v: number = n % 100;
      return n.toString() + (s[(v - 20) % 10] || s[v] || s[0]).toString();
    } else return '';
  }

  get isWeeklyPlan(): boolean {
    return (
      (this.planIntervalType &&
        this.planIntervalType?.toString() ==
        PlanIntervalType[PlanIntervalType.Week]) ||
      false
    );
  }

  get isDayPlan(): boolean {
    return false;
    // return (this.planIntervalType && this.planIntervalType?.toString() == PlanIntervalType[PlanIntervalType.Day]) || false;
  }

  get isMonthlyPlan(): boolean {
    return (
      (this.planIntervalType &&
        this.planIntervalType?.toString() ==
        PlanIntervalType[PlanIntervalType.Month]) ||
      false
    );
  }

  ResendPaymentLink(mode: string) {
    let channels: any[] = [];
    channels.push(mode);
    this.subscriptionService.resendPaymentLink(this.tenantId, this.clientId, this.uuid, channels).subscribe({
      next: (subscp: any) => {
        this.translate.get('SUBSCRIPTIONS.MSG_RESEND_LINK')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
      },
      error: (error) => {
        if (error.originalError.status == 200) {
          this.toastMessageService.showSuccess(error.originalError.error.text);
        }
        else if(error.originalError.error &&  Array.isArray(error.originalError.error) && error.originalError.error.length>0)
          {
            error.originalError.error.forEach((element: NotificationError) => {
              if(element.success)
                {
                  this.translate.get('SEND_EMAIL.MSG.EMAIL_SEND')
                  .subscribe((translation) => {
                    this.toastMessageService.showSuccess(translation);
                  });
                }
                else
                this.toastMessageService.showErrorMessage(element.error.errorMessage);
            });
          }
        else {
          this.handleError(error);
        }
      },
    });
  }

  handleError(error: any) {
    if (error instanceof NotFoundError) {
      this.translate
        .get([
          'common.errors.SERVER_SIDE.ERROR_OCCURRED',
          'SUBSCRIPTIONS.MSG_NOT_FOUND',
        ])
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations['SUBSCRIPTIONS.MSG_NOT_FOUND']);
        });
    } else {
      this.translate
        .get([
          'common.errors.SERVER_SIDE.ERROR_OCCURRED',
          'common.errors.SERVER_SIDE.SOMETHING_WRONG',
        ])
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations['common.errors.SERVER_SIDE.SOMETHING_WRONG']);
        });
    }
  }

  setTimeLineStatus(res: SignUpStatus) {

    let index = this.subscriptionSignUpStatusArray.findIndex((o) => o.key == res
      || o.key.toString().toLowerCase() == SignUpStatus[res].toString().toLowerCase());
    for (let i = 0; i <= index; i++) {
      this.subscriptionSignUpStatusArray[i].status = "Done";
      this.subscriptionSignUpStatusArray[i].icon = "fa fa-check";
    }

    if (index != this.subscriptionSignUpStatusArray.length - 1) {
      this.subscriptionSignUpStatusArray[index + 1].status = "Pending";
    }

    if (res == SignUpStatus.SignUpFailed || res.toString() == SignUpStatus[SignUpStatus.SignUpFailed]
      || res == SignUpStatus.SignUpExpired || res.toString() == SignUpStatus[SignUpStatus.SignUpExpired]) {

      this.subscriptionSignUpStatusArray[this.subscriptionSignUpStatusArray.length - 1].status = "Error";
      this.subscriptionSignUpStatusArray[this.subscriptionSignUpStatusArray.length - 1].icon = "Not Done";

    }
    // this.showLoader = false;
    // this.timerSubscription.unsubscribe();

  }

  setHidePaymentSideBar() {
    this.showPaymentStatusSidebar = false;
    this.hidePaymentSummaryPopup.emit(this.showPaymentStatusSidebar);
    this.hidePaymentSummaryPopup.emit(false);
  }

  GoToCLientProfile() {
    this.showPaymentStatusSidebar = false;
    //this.hidePaymentSummaryPopup.emit(false);
    this.GoToClientSubscription.emit(true);
  }

  isRecurring(oData: SubscriptionSignUpOrderSummaryResponse): boolean {
    return (
      oData &&
      oData.subscription_category &&
      (oData.subscription_category == PlanCategory.Contract ||
        oData.subscription_category.toString() ==
        PlanCategory[PlanCategory.Contract] ||
        oData.subscription_category == PlanCategory.PayAsYouGo ||
        oData.subscription_category.toString() ==
        PlanCategory[PlanCategory.PayAsYouGo])
    );
  }
}


function SIGNUPSTEP_INFO(SIGNUPSTEP_INFO: any) {
  throw new Error('Function not implemented.');
}

function title(
  title: any,
  arg1: string,
  text: any,
  arg3: string,
  icon: any,
  arg5: string,
  step: any,
  arg7: number,
  status: string,
  arg9: string
) {
  throw new Error('Function not implemented.');
}
